<template>
  <div class="simulation-point-group">
    <Group
      ref="pointGroups"
      v-for="group in simulationLocationGroups.simulationLocationGroups"
      @change="checkIsSimulatable()"
      @changeIsSelectedPoiLocationGroup="changeIsSelectedPoiLocationGroup"
      :key="group.id"
      :form="form"
      :group="group"
      :simulation-location-groups="simulationLocationGroups"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScrollMagic from 'scrollmagic'
import Group from './SimulationContentDeliverySidebarGroup'
import { modes } from '@/vuex/modules/simulation/constants'

export default {
  name: 'SimulationContentDeliverySidebarGroupList',
  components: {
    Group,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    simulationLocationGroups: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      controller: null,
      enableSimulation: null,
    }
  },
  computed: {
    ...mapGetters('simulation', ['selectedGroupId']),
    ...mapGetters('simulation', ['mode']),
    readonly() {
      return this.mode === modes.READONLY
    },
    menuSetting() {
      return this.form.deliverySetting.menuSetting
    },
  },
  watch: {
    selectedGroupId(id) {
      this.destroyScrollMagic()
      if (id === null) {
        return
      }

      this.$nextTick(() => {
        const index = this.simulationLocationGroups.simulationLocationGroups.findIndex(
          group => id === group.id,
        )
        if (index === -1) {
          return
        }
        const targetComponent = this.$refs.pointGroups[index]
        this.initScrollMagic(targetComponent.$refs.actions)
      })
    },
  },
  beforeDestroy() {
    this.destroyScrollMagic()
  },
  methods: {
    initScrollMagic(el) {
      this.controller = new ScrollMagic.Controller()
      const offset = this.$parent.$el.getBoundingClientRect().top
      const scene = new ScrollMagic.Scene({
        triggerElement: el,
        triggerHook: 0,
        offset: -offset,
      }).setPin(el)

      this.controller.addScene(scene)
    },
    destroyScrollMagic() {
      if (this.controller) {
        this.controller.destroy(true)
        this.controller = null
      }
    },
    checkIsSimulatable() {
      this.enableSimulation = !this.menuSetting.isUpperSimulationLocationsLimit()
      return this.enableSimulation
    },
    changeIsSelectedPoiLocationGroup(status) {
      this.$emit('changeIsSelectedPoiLocationGroup', status)
    },
  },
}
</script>

<style lang="scss">
.simulation-point-group {
  min-height: 0;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE, Edge 対応 */
  scrollbar-width: none;
}
.simulation-point-group::-webkit-scrollbar {
  /* Chrome, Safari 対応 */
  display: none;
}
</style>
